<div class="k-form">
  <kendo-dropdownlist
    textField="display"
    valueField="value"
    class="mb-1"
    [data]="operationList"
    [(ngModel)]="selectedOperation"
    (valueChange)="onGreaterChange($event)"
  />
  @if (selectedOperation.value === 1 || selectedOperation.value === 3) {
    <kendo-label
      text="{{ selectedOperation.value === 3 ? 'Greater Than' : null }}"
      [for]="greater"
    />
    <kendo-textbox
      #greater
      style="width: 99%"
      class="mb-1"
      [fillMode]="'outline'"
      [value]="equalGreater"
      [maskito]="dollarMask"
      (valueChange)="onGreaterChange($event)"
    />
  }
  @if (selectedOperation.value === 2 || selectedOperation.value === 3) {
    <kendo-label
      text="{{ selectedOperation.value === 3 ? 'Less Than' : null }}"
      [for]="less"
    />
    <kendo-textbox
      #less
      style="width: 99%"
      class="mb-1"
      [fillMode]="'outline'"
      [value]="equalLess"
      [maskito]="dollarMask"
      (valueChange)="onLessChange($event)"
    />
  }
</div>
